import { Injectable } from '@angular/core';
import { ApiResponse, VisibaApiHttp } from '../../../Classes/visibaHttp.class';

export interface ComplianceSettings {
	AllowEmail: boolean;
	AllowSms: boolean;
	UpToDate: boolean;
}

export interface ComplianceSettingsInput {
	allowEmail: boolean;
	allowSms: boolean;
}

@Injectable()
export class NotificationSettingsService {
	private readonly baseUri = '/api/Client/v2/notificationsettings';

	constructor(private http: VisibaApiHttp) {}

	public getComplianceSettings() {
		return this.http.getTyped<ComplianceSettings>(`${this.baseUri}/Compliance`);
	}

	public putComplianceSettings(settings: ComplianceSettingsInput) {
		return this.http.putTyped<ComplianceSettingsInput>(`${this.baseUri}/Compliance`, settings);
	}
}
